e4.product = {
    init: function () {
        if ( jQuery( '.js-e-product-form' ).length > 1 ) {
            e4.cart.event = e4.util.registerEvents( 'add added update updated', 'cart' );
            e4.product.bindEvents();
            e4.product.setProductFormRedirect();
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.validate();
            } );
            jQuery( '.js-e-product-form' ).find( 'input').each( function ( index, element ){
                e4.product.updatePrice( element );
            });
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-product-form' ).on( 'input', function ( event ) {
            e4.product.updatePrice( event.target );
        } );
    },
    validate: function () {
        jQuery( '.js-e-product-form' ).each( function () {
            jQuery( this ).validate( {
                submitHandler: function ( domForm ) {
                    e4.product.addToCart( domForm );
                }
            } );
        } );
    },
    setProductFormRedirect: function () {
        jQuery( '.js-e-product-form' ).find( 'input[name="Redirect"]' ).val( 'false' );
    },
    addToCart: function ( domForm ) {
        // event.preventDefault();
        var arrFormData = jQuery( domForm ).serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        e4.cart.addProduct( objFormData );
    },
    updatePrice: function ( domInput ) {
        var intPrice       = 0.00,
            jForm          = jQuery( domInput.form ),
            strLoopCounter = jForm.data( 'loopCounter' ),
            jPrice         = jQuery( '.js-fku-price-' + strLoopCounter ),
            intLength      = fku.util.formatStringToJavascriptNumber( jForm.find( '.js-fku-length-' + strLoopCounter ).val() ),
            intQuantity    = fku.util.formatStringToJavascriptNumber( jForm.find( '.js-fku-quantity-' + strLoopCounter ).val() ),
            intPriceBase   = fku.util.formatStringToJavascriptNumber( jPrice.data( 'priceBase' ) ),
            intPriceMeter  = fku.util.formatStringToJavascriptNumber( jPrice.data( 'priceMeter' ) ),
            intStockType   = fku.util.formatStringToJavascriptNumber( jPrice.data( 'stockType' ) ),
            intMultiplier  = ( intStockType > 300 ) ? intStockType - 300 : 1;
        
        console.log(intPriceBase, intPriceMeter, intMultiplier, intLength, intQuantity, intStockType);
        if ( isNaN( intQuantity ) === false && isNaN( intLength ) === false ) {
            intPrice = ( intPriceBase + intPriceMeter * intLength * intMultiplier ) * intQuantity;
            //console.log(intPriceBase, intPriceMeter, intLength, intMultiplier, intQuantity);
        }
        jPrice.find( '.e-price-price' ).html( fku.util.formatJavascriptNumberToString( intPrice ) );
    }
};

